import React from 'react';

const NotFound = () => {
  const [buttonHovered, setButtonHovered] = React.useState(false);



  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
    },
    title: {
      fontSize: '4rem',
      color: '#343a40',
      marginBottom: '0.5rem',
    },
    message: {
      fontSize: '1.5rem',
      color: '#6c757d',
      marginBottom: '2rem',
    },
    button: {
      padding: '0.5rem 1.5rem',
      fontSize: '1.2rem',
      color: '#fff',
      backgroundColor: '#007bff',
      border: 'none',
      borderRadius: '0.25rem',
      cursor: 'pointer',
      textDecoration: 'none',
    },
    buttonHover: {
      backgroundColor: '#0056b3',
    },
  };
  
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>404 - Not Found</h1>
      <p style={styles.message}>The page you are looking for does not exist.</p>
      <a
        href="/"
        style={buttonHovered ? { ...styles.button, ...styles.buttonHover } : styles.button}
        onMouseEnter={() => setButtonHovered(true)}
        onMouseLeave={() => setButtonHovered(false)}
      >
        Go to Home
      </a>
    </div>
  );
};

export default NotFound